import Checkbox from '@xunlei/thunder-ui-vue/lib/checkbox.js';
import Icon from '@xunlei/thunder-ui-vue/lib/icon.js';

var NAMESPACE = 'td';

var Tree = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-tree" });
  }, staticRenderFns: [],
  name: NAMESPACE + '-tree'
};

var TreeNode = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-tree-node", class: { 'is-expanded': _vm.expanded }, style: { 'padding-left': _vm.level * 20 + 'px' } }, [_c('div', { staticClass: "td-tree-node__content" }, [_vm.treeEnabled ? _c('td-icon', { staticClass: "td-tree-node__expand-icon", class: { 'is-expanded': _vm.expanded, 'is-hidden': !_vm.$slots.default && !_vm.expandable }, attrs: { "type": "arrow-drop" }, nativeOn: { "click": function click($event) {
          return _vm.handleExpandIconClick($event);
        } } }) : _vm._e(), _vm._v(" "), _vm.checkable ? _c('td-checkbox', { attrs: { "indeterminate": _vm.indeterminate, "value": _vm.checked, "disabled": _vm.disabled }, on: { "input": _vm.handleInput } }) : _vm._e(), _vm._v(" "), _vm.$slots.icon ? _c('span', { staticClass: "td-tree-node__image-icon", on: { "click": _vm.handleClickLabel, "dblclick": _vm.handleDbclickLabel } }, [_vm._t("icon")], 2) : _vm._e(), _vm._v(" "), _c('span', { staticClass: "td-tree-node__label", on: { "click": _vm.handleClickLabel, "dblclick": _vm.handleDbclickLabel } }, [_vm._t("label", [_vm._v(_vm._s(_vm.label))])], 2)], 1), _vm._v(" "), _vm.$slots.default ? _c('div', { staticClass: "td-tree-node__children" }, [_vm._t("default")], 2) : _vm._e()]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-tree-node',

  components: {
    TdCheckbox: Checkbox,
    TdIcon: Icon
  },

  props: {
    label: String,
    level: Number,
    checked: Boolean,
    disabled: Boolean,
    expanded: Boolean,
    indeterminate: Boolean,
    checkable: Boolean,
    expandable: Boolean,
    treeEnabled: Boolean
  },

  methods: {
    handleClickLabel: function handleClickLabel() {
      this.$emit('click-label');
    },
    handleExpandIconClick: function handleExpandIconClick() {
      this.$emit('update:expanded', !this.expanded);
    },
    handleInput: function handleInput(checked) {
      this.$emit('change', checked);
    },
    handleDbclickLabel: function handleDbclickLabel() {
      this.$emit('dbclick-label');
    }
  }
};

Tree.install = function (Vue) {
  Vue.component(Tree.name, Tree);
  Vue.component(TreeNode.name, TreeNode);
};

export default Tree;
export { TreeNode };
